const initialState = {
    info: {
    }
}

export const espeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ESPE_SUCCESS':
            return { loading: false, ...action.payload }
        case 'ESPE_FAIL':
            return { loading: false, error: action.payload }
        default:
            return state
    }
}